import React, { Component } from 'react'
import { CLOUDS, SILVER } from '../utils/colors'


class Header extends Component {

    render() {
        return (
            <div className='hero'>
                <div className='hero-body'>
                    <div className='container'>
                        <h1 className='title' style={{color: CLOUDS}}>
                            {`${this.props.title}`}
                        </h1>
                        <h2 className='subtitle' style={{color: SILVER}}>
                            {`${this.props.subtitle}`}
                        </h2>
                    </div>
                </div>
            </div>
        )
    }

}


export default Header



// WEBPACK FOOTER //
// ./src/components/header.js